(function () {
  const YEARS_FILTER = 'filter.p.m.custom.filter_years';
  const HISTORY_KEY = 'evmCarSearchHistory';
  const SELECTION_KEY = 'carFilterSelections';
  const HISTORY_MAX = 5;
  const QUICK_LIMIT = 5;
  const POPULAR_MAKES = ['Toyota', 'Audi', 'Ford', 'Volkswagen'];
  const POPULAR_MODELS = {
    Toyota: ['Corolla', 'RAV4', 'Yaris', 'Avensis'],
    Audi: ['A6', 'A4', 'A3', 'Q5'],
    Ford: ['Fiesta', 'Kuga', 'Focus', 'Mondeo'],
    Volkswagen: ['Touran', 'Sharan', 'Polo', 'Amarok'],
  };
  const BRAND_ALIASES = {
    vw: 'volkswagen',
    volkswagen: 'volkswagen',
    skoda: 'skoda',
    mercedes: 'mercedes benz',
    benz: 'mercedes benz',
    'mercedes benz': 'mercedes benz',
    bmw: 'bmw',
    audi: 'audi',
    toyota: 'toyota',
    opel: 'opel',
    ford: 'ford',
    hyundai: 'hyundai',
    kia: 'kia',
    mazda: 'mazda',
    volvo: 'volvo',
    peugeot: 'peugeot',
    renault: 'renault',
  };

  /* Słowa nadwozia z zapytania (29.09): „b8 avant”, „f31 touring”, „passat variant” → kombi. */
  const BODY_ALIASES = {
    avant: 'kombi', touring: 'kombi', variant: 'kombi', estate: 'kombi', combi: 'kombi', wagon: 'kombi', tourer: 'kombi', sw: 'kombi',
    limuzyna: 'sedan', saloon: 'sedan', cabrio: 'kabriolet', convertible: 'kabriolet', cabriolet: 'kabriolet',
  };
  const BODY_WORDS = ['kombi', 'sedan', 'hatchback', 'coupe', 'kabriolet', 'suv', 'liftback', 'van', 'pickup', 'roadster', 'minivan'];
  /* 05.10 przegląd: nadwozie porównujemy bez spacji i myślników („Pick-up” = pickup) i ze słowami-aliasami
     („Coupe/cabrio” = kabriolet) — wcześniej „navara d40 pickup” nie znajdowało nic */
  function bodyHas(body, word) {
    const text = compact(body);
    if (text.indexOf(word) !== -1) return true;
    return Object.keys(BODY_ALIASES).some((alias) => BODY_ALIASES[alias] === word && text.indexOf(alias) !== -1);
  }

  const root = document.getElementById('evm-cs');
  if (!root) return;

  const els = {
    title: root.querySelector('#evm-cs-title'),
    subtitle: root.querySelector('[data-evm-cs-subtitle]'),
    context: root.querySelector('[data-evm-cs-context]'),
    form: root.querySelector('[data-evm-cs-form]'),
    input: root.querySelector('#evm-cs-input'),
    clear: root.querySelector('[data-evm-cs-clear]'),
    body: root.querySelector('[data-evm-cs-body]'),
  };

  const i18n = parseJson(document.getElementById('evm-cs-i18n'), {});
  // Telefon: pełne «Marka, model lub kod nadwozia» nie mieści się w polu (mierzone 29.09) — krótsza wersja, też z «kod nadwozia».
  const narrowScreen = window.matchMedia ? window.matchMedia('(max-width: 749px)') : null;
  const logos = {};
  const makeUrls = {};
  parseJson(document.getElementById('evm-cs-brand-logos'), []).forEach((item) => {
    if (item && item.title) {
      if (item.src) logos[fold(item.title)] = item.src;
      if (item.url) makeUrls[fold(item.title)] = item.url;
    }
  });

  const state = {
    open: false,
    step: 'make',
    query: '',
    showAll: false,
    entry: 'default',
    searchMethod: '',
    make: '',
    model: '',
    modelUrl: '',
    year: '',
    yearRange: '',
    years: [],
    yearsLoading: false,
    yearsError: false,
    unavailable: false,
    trackedInput: false,
    trackedFocus: false,
  };

  let catalog = null;
  let catalogPromise = null;
  let yearsCache = {};
  /* Netpeak S3 (23.09.2026): lista produktów kolekcji (url + lata) z tego samego ?view=json — do skrótu „jeden produkt”. */
  let productsCache = {};
  let lastFocus = null;
  /* Kody nadwozia (29.09.2026, grey): W204, F40, B8, MK7… z assets/evm-body-codes.json — indeks budowany z tytułów
     aktywnych produktów (Claude EVAMATS/body-code-search/build-index.mjs). Jeden wiersz = jeden produkt, więc klik
     prowadzi od razu do właściwych dywaników, bez zgadywania nadwozia. */
  let codeRows = null;
  let codesPromise = null;
  /* numer otwarcia okna — odpowiedź katalogu dla kafelka marki dotyczy tylko „swojego” otwarcia (openMake) */
  let openSeq = 0;

  function parseJson(node, fallback) {
    if (!node) return fallback;
    try {
      return JSON.parse(node.textContent || '');
    } catch (error) {
      return fallback;
    }
  }

  function fold(value) {
    return String(value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/ł/g, 'l')
      .replace(/ß/g, 'ss')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }

  function compact(value) {
    return fold(value).replace(/\s+/g, '');
  }

  function popularModelIndex(make, model) {
    const names = POPULAR_MODELS[make] || [];
    const needle = compact(model);
    return names.findIndex((name) => compact(name) === needle);
  }

  function t(key, vars) {
    let text = i18n[key] || key;
    Object.keys(vars || {}).forEach((name) => {
      text = text.replace(new RegExp('\\{' + name + '\\}', 'g'), String(vars[name] == null ? '' : vars[name]));
    });
    return text;
  }

  /* adresy awaryjne z prefiksem języka (/en/…) — Shopify.routes.root; sam „/” wyrzucał klienta EN na polską stronę */
  function localUrl(path) {
    const prefix = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return prefix + String(path).replace(/^\//, '');
  }

  function brandUrl(brand) {
    return makeUrls[fold(brand)] || localUrl('pages/dywaniki-samochodowe-eva');
  }

  function track(event, extra) {
    const payload = Object.assign(
      {
        event: event,
        entry_point: state.entry,
        step: state.step,
        query: state.query || undefined,
        search_method: state.searchMethod || undefined,
        selected_make: state.make || undefined,
        selected_model: state.model || undefined,
        selected_year: state.year || state.yearRange || undefined,
      },
      extra || {}
    );
    Object.keys(payload).forEach((key) => {
      if (payload[key] == null || payload[key] === '') delete payload[key];
    });
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
    /* Netpeak №13–16 (24.09.2026): te same zdarzenia idą do Shopify.analytics, jak zdarzenia konfiguratora
       (evm-configurator-analytics.js) — piksel w Customer events przekazuje je do GA4. */
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        const data = Object.assign({}, payload);
        delete data.event;
        window.Shopify.analytics.publish(event, data);
      }
    } catch (error) {
      /* analityka nie może zatrzymać wyszukiwarki */
    }
  }

  function loadCatalog() {
    loadCodes(); /* także po udanym katalogu: nieudane pobranie kodów ponawiamy przy kolejnym otwarciu */
    if (catalog) return Promise.resolve(catalog);
    if (catalogPromise) return catalogPromise;
    const url = window.__evamatsAllBrandsUrl;
    if (!url) return Promise.resolve(null);
    catalogPromise = fetch(url)
      .then((response) => {
        if (!response.ok) throw new Error('all_brands.json ' + response.status);
        return response.json();
      })
      .then((data) => {
        catalog = buildCatalog(data);
        return catalog;
      })
      .catch((error) => {
        console.warn('[evm-car-search]', error);
        catalogPromise = null;
        return null;
      });
    return catalogPromise;
  }

  function buildCatalog(data) {
    const makes = [];
    const models = [];
    Object.keys(data || {}).forEach((brandKey) => {
      const brand = String(brandKey || '').trim();
      if (!brand) return;
      const brandFold = fold(brand);
      makes.push({
        kind: 'make',
        make: brand,
        url: brandUrl(brand),
        haystack: brandFold + ' ' + (BRAND_ALIASES[brandFold] || ''),
        logo: logos[brandFold] || '',
      });
      ((data[brandKey] && data[brandKey].models) || []).forEach((model) => {
        const name = String((model && model.name) || '').trim();
        if (!name) return;
        models.push({
          kind: 'model',
          make: brand,
          model: name,
          url: String((model && model.url) || '').trim() || brandUrl(brand),
          haystack: (brandFold + ' ' + fold(name)).trim(),
          logo: logos[brandFold] || '',
        });
      });
    });
    makes.sort((a, b) => a.make.localeCompare(b.make, undefined, { sensitivity: 'base' }));
    return { makes, models };
  }

  function levenshtein(a, b) {
    if (a === b) return 0;
    if (!a.length) return b.length;
    if (!b.length) return a.length;
    const row = Array.from({ length: b.length + 1 }, (_, i) => i);
    for (let i = 1; i <= a.length; i += 1) {
      let prev = i - 1;
      row[0] = i;
      for (let j = 1; j <= b.length; j += 1) {
        const cur = row[j];
        const cost = a[i - 1] === b[j - 1] ? 0 : 1;
        row[j] = Math.min(row[j] + 1, row[j - 1] + 1, prev + cost);
        prev = cur;
      }
    }
    return row[b.length];
  }

  /* 14.10.2026: rok to 2 cyfry albo 4 cyfry z lat 1950–2100. Wcześniej „rokiem” było każde 2–4-cyfrowe słowo, więc samo „500”,
     „208”, „3008” albo „e-2008” (nazwy modeli) znikały z zapytania i wyszukiwarka nic nie znajdowała. */
  function isYearToken(token) {
    if (/^\d{2}$/.test(token)) return true;
    return /^\d{4}$/.test(token) && +token >= 1950 && +token <= 2100;
  }

  function parseYearToken(query) {
    const years = fold(query).split(/\s+/).filter(isYearToken);
    if (state.step === 'year') return years[0] || '';
    /* liczba, która jest nazwą modelu („2008” u Peugeota), nie jest rokiem */
    return years.filter((token) => !isModelName(compact(token)))[0] || '';
  }

  /* keepModelNumbers = true: słowa-liczby, które są nazwą modelu („208”, „500”, „2008”), zostają w zapytaniu; usuwamy tylko to, co
     wygląda na rok i nie jest nazwą. false: dawna zasada — każde słowo 2–4-cyfrowe (np. „320” w „bmw 320”) to dopisek do pominięcia.
     Samo zapytanie z liczb („500”, „e-2008”) zostaje całe: to nazwa modelu, nie rok. */
  function queryWithoutYear(query, keepModelNumbers) {
    const tokens = fold(query).split(/\s+/).filter(Boolean);
    const rest = tokens.filter((token) => keepModelNumbers ? (!isYearToken(token) || isModelName(compact(token))) : !/^\d{2,4}$/.test(token)).join(' ');
    return rest.replace(/\s/g, '').length >= 2 ? rest : tokens.join(' ');
  }

  function scoreRow(row, tokens) {
    const hay = ' ' + row.haystack + ' ';
    const hayCompact = compact(row.haystack);
    const nameFold = fold(row.kind === 'make' ? row.make : row.model);
    const nameCompact = compact(row.kind === 'make' ? row.make : row.model);
    const makeFold = fold(row.make);
    let score = row.kind === 'model' ? 80 : 40;
    for (let i = 0; i < tokens.length; i += 1) {
      const token = BRAND_ALIASES[tokens[i]] || tokens[i];
      const parts = String(token).split(/\s+/).filter(Boolean);
      const compactToken = compact(token);
      const ok = parts.every((part) => hay.indexOf(' ' + part) !== -1 || hay.indexOf(part) !== -1) ||
        (compactToken && hayCompact.indexOf(compactToken) !== -1);
      if (!ok) return 0;
      if (nameFold === token || nameCompact === compactToken) score += 50;
      else if (nameFold.indexOf(token) === 0 || nameCompact.indexOf(compactToken) === 0) score += 28;
      else if (nameFold.indexOf(token) !== -1 || nameCompact.indexOf(compactToken) !== -1) score += 18;
      else if (makeFold === token || makeFold.indexOf(token) === 0) score += 12;
      else score += 4;
    }
    if (row.kind === 'model') {
      const popularIndex = popularModelIndex(row.make, row.model);
      if (popularIndex !== -1) score += 36 - popularIndex;
    }
    if (row.kind === 'make' && POPULAR_MAKES.some((name) => fold(name) === fold(row.make))) score += 6;
    return score;
  }

  function loadCodes() {
    if (codeRows) return Promise.resolve(codeRows);
    if (codesPromise) return codesPromise;
    const url = window.__evmBodyCodesUrl;
    if (!url) return Promise.resolve(null);
    codesPromise = fetch(url)
      .then((response) => {
        if (!response.ok) throw new Error('evm-body-codes.json ' + response.status);
        return response.json();
      })
      .then((data) => {
        codeRows = ((data && data.rows) || []).map((r) => ({
          kind: 'code',
          make: r[0],
          model: r[1],
          codes: r[2] || [],
          codeKeys: (r[2] || []).map(compact),
          note: r[3] || '',
          body: r[4] || '',
          years: r[5] || '',
          url: localUrl('products/' + r[6]),
          label: r[7] || r[1],
          /* kod bez marki tylko tam, gdzie kody są zwyczajem (BMW, Mercedes, Audi, VW…); reszta: z modelem/marką */
          scope: r[8] === undefined ? true : !!r[8],
          logo: logos[fold(r[0])] || '',
          haystack: fold([r[0], BRAND_ALIASES[fold(r[0])] || '', r[1], r[7], r[4], r[3]].join(' ')),
        }));
        if (state.open && state.query) render();
        return codeRows;
      })
      .catch((error) => {
        console.warn('[evm-car-search]', error);
        codesPromise = null;
        return null;
      });
    return codesPromise;
  }

  /* Token kodu = litery + cyfry (w204, f40, mk7, 8v). „mk 7” i „w 204” sklejamy. Pozostałe słowa zawężają
     (marka, model, nadwozie), a czterocyfrowy rok musi wpaść w lata produkcji wiersza. */
  function codeTokens(query) {
    const raw = fold(query).split(/\s+/).filter(Boolean);
    const out = [];
    for (let i = 0; i < raw.length; i += 1) {
      const a = raw[i];
      const b = raw[i + 1];
      if (b && /^[a-z]{1,3}$/.test(a) && /^\d{1,3}$/.test(b)) {
        out.push(a + b);
        i += 1;
      } else out.push(a);
    }
    return out;
  }

  /* 05.10 przegląd: najpierw wszystkie słowa muszą pasować; gdy nic nie zostaje, słowa spoza katalogu („lift”, „lci”, „tdi”,
     „gti”, rok „08”) tylko pomagają w kolejności, nie wykluczają kodu. Nazwa marki dalej musi pasować („w204 bmw” = nic). */
  function codeHits(query) {
    const strict = codeHitsWith(query, false);
    return strict.length ? strict : codeHitsWith(query, true);
  }
  function isModelName(tok) {
    return !!catalog && catalog.models.some((row) => compact(row.model) === tok);
  }
  function isBrandWord(tok) {
    return !!BRAND_ALIASES[tok] || (!!catalog && catalog.makes.some((row) => fold(row.make).split(' ').indexOf(tok) !== -1));
  }
  function codeHitsWith(query, lenient) {
    if (!codeRows || (state.step !== 'make' && state.step !== 'model')) return [];
    const tokens = codeTokens(query);
    let codeLike = tokens.filter((tok) => /[a-z]/.test(tok) && /\d/.test(tok) && tok.length >= 2 && tok.length <= 6);
    /* „a4 b8”: A4 to nazwa modelu — zawęża (Audi A4), a nie jest drugim kodem do wyboru */
    if (codeLike.length > 1) {
      const names = codeLike.filter(isModelName);
      if (names.length && names.length < codeLike.length) codeLike = codeLike.filter((tok) => names.indexOf(tok) === -1);
    }
    if (!codeLike.length) return [];
    const hits = [];
    codeRows.forEach((row) => {
      /* po wyborze marki: tylko jej wiersze (każda marka, także Škoda A7 czy Nissan Z33) */
      if (state.step === 'model' && row.make !== state.make) return;
      let score = 0;
      let matched = '';
      for (let i = 0; i < codeLike.length && !matched; i += 1) {
        const tok = codeLike[i];
        const exact = row.codeKeys.indexOf(tok);
        if (exact !== -1) {
          score = 300;
          matched = row.codes[exact];
        } else {
          const prefix = row.codeKeys.findIndex((key) => key.indexOf(tok) === 0);
          if (prefix !== -1 && /^[a-z]{1,3}\d{2,}$/.test(tok)) {
            score = 180;
            matched = row.codes[prefix];
          }
        }
      }
      if (!matched) return;
      const hay = ' ' + row.haystack + ' ';
      /* inne tokeny-kody („e90 e91”) to alternatywy, nie zawężenie */
      const rest = tokens.filter((tok) => codeLike.indexOf(tok) === -1);
      let named = state.step === 'model';
      for (let i = 0; i < rest.length; i += 1) {
        const tok = BODY_ALIASES[rest[i]] || BRAND_ALIASES[rest[i]] || rest[i];
        if (/^\d{4}$/.test(tok)) {
          const range = parseYearRange(row.years);
          if (!range || +tok < range.start || +tok > range.end) return;
          score += 20;
        } else if (lenient && /^\d{2}$/.test(tok)) {
          /* rok dwucyfrowy („w204 08”) — tylko w trybie łagodnym; spoza lat produkcji nie wyklucza */
          const range = parseYearRange(row.years);
          const year = +tok + (+tok < 50 ? 2000 : 1900);
          if (range && year >= range.start && year <= range.end) score += 20;
        } else if (BODY_WORDS.indexOf(tok) !== -1) {
          /* produkt bez nadwozia w tytule (Audi: wybór Sedan/Kombi w konfiguratorze) pasuje do każdego nadwozia */
          if (row.body && !bodyHas(row.body, tok)) return;
          score += row.body ? 15 : 5;
        } else if (hay.indexOf(' ' + tok) === -1) {
          if (!lenient || isBrandWord(tok) || isModelName(compact(tok))) return;
        } else {
          named = true;
          score += 10;
        }
      }
      if (!row.scope && !named) return;
      hits.push(Object.assign({ score: score, matched: matched }, row));
    });
    hits.sort((a, b) => b.score - a.score || a.make.localeCompare(b.make) || a.label.localeCompare(b.label) || a.years.localeCompare(b.years));
    return hits;
  }

  function searchCatalog(query, limit) {
    if (!catalog) return [];
    /* najpierw liczby-nazwy modeli zostają w zapytaniu („peugeot 208”), potem — gdy nic nie pasuje — liczba jest rokiem („bmw 2008”) */
    const named = queryWithoutYear(query, true);
    const first = searchCatalogFor(named, limit);
    if (first.length) return first;
    const plain = queryWithoutYear(query, false);
    return plain !== named ? searchCatalogFor(plain, limit) : first;
  }

  function searchCatalogFor(folded, limit) {
    if (!catalog) return [];
    if (folded.length < 2) return [];
    const tokens = folded.split(/\s+/).filter(Boolean).map((token) => BRAND_ALIASES[token] || token);
    const scored = [];
    const pool = state.step === 'model'
      ? catalog.models.filter((row) => fold(row.make) === fold(state.make))
      : catalog.makes.concat(catalog.models);
    pool.forEach((row) => {
      const score = scoreRow(row, tokens);
      if (score) scored.push(Object.assign({ score: score }, row));
    });
    scored.sort((a, b) => b.score - a.score || a.make.localeCompare(b.make) || String(a.model || '').localeCompare(String(b.model || '')));
    const makes = scored.filter((row) => row.kind === 'make');
    const models = scored.filter((row) => row.kind === 'model');
    const queryCompact = compact(folded);
    const exactModels = models.filter((row) => compact(row.model) === queryCompact);
    const prefixMake = makes.find((row) => compact(row.make).indexOf(queryCompact) === 0);
    const mixed = [];
    const pushUnique = (row) => {
      if (mixed.some((item) => item.kind === row.kind && item.make === row.make && item.model === row.model)) return;
      mixed.push(row);
    };
    if (exactModels.length) {
      exactModels.forEach(pushUnique);
      models.forEach(pushUnique);
      makes.forEach(pushUnique);
    } else {
      if (prefixMake) pushUnique(prefixMake);
      models.forEach(pushUnique);
      makes.forEach(pushUnique);
    }
    if (!limit) return mixed;
    return mixed.slice(0, limit);
  }

  function fuzzyCatalog(query, limit) {
    if (!catalog) return [];
    const folded = queryWithoutYear(query);
    if (folded.length < 4) return [];
    const pool = state.step === 'model'
      ? catalog.models.filter((row) => fold(row.make) === fold(state.make))
      : catalog.makes.concat(catalog.models);
    const hits = [];
    pool.forEach((row) => {
      const target = fold(row.kind === 'make' ? row.make : row.make + ' ' + row.model);
      const dist = Math.min(levenshtein(folded, fold(row.make)), levenshtein(folded, target), levenshtein(folded, fold(row.model || '')));
      const max = folded.length <= 5 ? 1 : 2;
      if (dist > 0 && dist <= max) hits.push(Object.assign({ score: 40 - dist * 10 }, row));
    });
    hits.sort((a, b) => b.score - a.score);
    const unique = [];
    hits.forEach((row) => {
      if (!unique.some((item) => item.kind === row.kind && item.make === row.make && item.model === row.model)) unique.push(row);
    });
    return unique.slice(0, limit || 3);
  }

  function parseYearRange(text) {
    const normalized = String(text || '').trim().replace(/\u2013|\u2014|\u2212/g, '-');
    const range = normalized.match(/(\d{4})\s*-\s*(\d{4})/);
    if (range) {
      let start = parseInt(range[1], 10);
      let end = parseInt(range[2], 10);
      if (isNaN(start) || isNaN(end)) return null;
      if (start > end) {
        const tmp = start;
        start = end;
        end = tmp;
      }
      return { start: start, end: end, label: String(text).trim() };
    }
    const single = normalized.match(/^(\d{4})$/);
    if (!single) return null;
    const year = parseInt(single[1], 10);
    return isNaN(year) ? null : { start: year, end: year, label: String(text).trim() };
  }

  function expandYears(ranges) {
    const years = new Set();
    /* 14.10.2026: lista nie proponuje lat, które jeszcze nie nadeszły („2025-2035” → do bieżącego roku). Rok czytany z zegara
       przeglądarki — nic nie trzeba poprawiać co roku; generacja, która zaczyna się dopiero w przyszłości, pokazuje swój
       pierwszy rok, żeby model dało się wybrać. */
    const thisYear = new Date().getFullYear();
    (ranges || []).forEach((label) => {
      const range = parseYearRange(label);
      if (!range) return;
      for (let year = Math.max(range.start, Math.min(range.end, thisYear)); year >= range.start; year -= 1) years.add(year);
    });
    return Array.from(years).sort((a, b) => b - a);
  }

  function pickRangeForYear(yearToken, ranges) {
    const year = parseInt(yearToken, 10);
    if (isNaN(year) || !Array.isArray(ranges) || !ranges.length) return '';
    const exact = ranges.find((label) => String(label).trim() === String(yearToken).trim());
    if (exact) return exact;
    const covering = ranges
      .map((label) => ({ label: label, range: parseYearRange(label) }))
      .filter((item) => item.range && year >= item.range.start && year <= item.range.end)
      .sort((a, b) => a.range.end - a.range.start - (b.range.end - b.range.start));
    return covering.length ? covering[0].label : '';
  }

  function fetchCollectionYears(collectionUrl) {
    const key = String(collectionUrl || '').split('?')[0];
    if (!key) return Promise.resolve([]);
    if (yearsCache[key]) return yearsCache[key];
    yearsCache[key] = (async () => {
      const fetchPage = async (page) => {
        const url = new URL(key, window.location.origin);
        url.searchParams.set('view', 'json');
        url.searchParams.set('page', String(page));
        const response = await fetch(url.pathname + url.search);
        if (!response.ok) throw new Error('HTTP ' + response.status);
        const body = await response.text();
        // The legacy collection.json view emits a dangling comma for empty collections.
        if (/^\s*\{\s*"total_products"\s*:\s*0\s*,/.test(body)) return { total_products: 0, products: [] };
        return JSON.parse(body);
      };
      const first = await fetchPage(1);
      const products = Array.isArray(first.products) ? first.products.slice() : [];
      const perPage = products.length;
      const totalPages = perPage > 0 ? Math.ceil((first.total_products || perPage) / perPage) : 1;
      if (totalPages > 1) {
        const rest = await Promise.all(Array.from({ length: totalPages - 1 }, (_, i) => fetchPage(i + 2)));
        rest.forEach((data) => {
          if (Array.isArray(data.products)) products.push(...data.products);
        });
      }
      productsCache[key] = products.filter((product) => product && typeof product === 'object' && product.url);
      const years = new Set();
      products.forEach((product) => {
        if (product && product.years != null && String(product.years).trim() !== '') years.add(String(product.years).trim());
      });
      return Array.from(years);
    })().catch((error) => {
      console.warn('[evm-car-search] years', key, error);
      delete yearsCache[key];
      return null;
    });
    return yearsCache[key];
  }

  /* A selected production year can match more than one product range. Keep every compatible
     range in the collection filter; only deep-link to a product when that year has one match. */
  function compatibleYearRanges() {
    const key = String(state.modelUrl || '').split('?')[0];
    const list = productsCache[key];
    if (!Array.isArray(list)) return [];
    const selectedYear = /^\d{4}$/.test(String(state.year || '').trim()) ? parseInt(state.year, 10) : null;
    if (selectedYear !== null && !isNaN(selectedYear)) {
      return Array.from(new Set(list.filter((product) => {
        const range = parseYearRange(product && product.years);
        return range && selectedYear >= range.start && selectedYear <= range.end;
      }).map((product) => String(product.years || '').trim()).filter(Boolean)));
    }
    const exactRange = String(state.yearRange || '').trim();
    return exactRange ? [exactRange] : [];
  }

  function singleProductUrl() {
    const key = String(state.modelUrl || '').split('?')[0];
    const list = productsCache[key];
    if (!Array.isArray(list) || !list.length) return '';
    const ranges = compatibleYearRanges();
    const pool = ranges.length ? list.filter((product) => ranges.includes(String(product.years || '').trim())) : list;
    return pool.length === 1 ? String(pool[0].url || '') : '';
  }

  function resultUrl() {
    const base = state.modelUrl || (state.make ? brandUrl(state.make) : '');
    if (!base) return '';
    const url = new URL(base, window.location.origin);
    const ranges = compatibleYearRanges();
    ranges.forEach((range) => url.searchParams.append(YEARS_FILTER, range));
    return url.pathname + url.search;
  }

  function saveSelection() {
    localStorage.setItem(
      SELECTION_KEY,
      JSON.stringify({
        brand: state.make,
        model: state.model,
        modelUrl: state.modelUrl,
        years: state.yearRange || state.year,
      })
    );
  }

  function readHistory() {
    try {
      const items = JSON.parse(localStorage.getItem(HISTORY_KEY) || '[]');
      return Array.isArray(items) ? items.slice(0, HISTORY_MAX) : [];
    } catch (error) {
      return [];
    }
  }

  function writeHistory(items) {
    localStorage.setItem(HISTORY_KEY, JSON.stringify(items.slice(0, HISTORY_MAX)));
  }

  function pushHistory() {
    const label = [state.make, state.model, state.year || state.yearRange].filter(Boolean).join(' ');
    if (!label) return;
    const items = readHistory().filter((item) => item.label !== label);
    items.unshift({
      label: label,
      make: state.make,
      model: state.model,
      modelUrl: state.modelUrl,
      year: state.year,
      yearRange: state.yearRange,
      url: resultUrl(),
    });
    writeHistory(items);
  }

  function headerOffset() {
    const header = document.querySelector('#shopify-section-header') || document.querySelector('sticky-header') || document.querySelector('.header-wrapper');
    return header ? Math.max(0, Math.round(header.getBoundingClientRect().bottom)) : 0;
  }

  function setOpen(open, focusInput) {
    state.open = open;
    root.hidden = !open;
    document.documentElement.classList.toggle('evm-cs-open', open);
    syncForeignModals();
    root.style.setProperty('--evm-cs-top', headerOffset() + 'px');
    if (open) {
      lastFocus = document.activeElement;
      if (focusInput) {
        /* rAF w karcie w tle nie odpala — zapasowy setTimeout (lint: inicjalizacja) */
        let focused = false;
        const focusOnce = () => { if (focused) return; focused = true; els.input.focus(); };
        window.requestAnimationFrame(focusOnce);
        setTimeout(focusOnce, 60);
      }
    } else if (lastFocus && typeof lastFocus.focus === 'function') {
      lastFocus.focus();
    }
  }

  function chevron() {
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('class', 'evm-cs__chevron');
    svg.setAttribute('width', '18');
    svg.setAttribute('height', '18');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('aria-hidden', 'true');
    const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path.setAttribute('d', 'M9 6l6 6-6 6');
    path.setAttribute('stroke', 'currentColor');
    path.setAttribute('stroke-width', '1.8');
    path.setAttribute('stroke-linecap', 'round');
    path.setAttribute('stroke-linejoin', 'round');
    svg.appendChild(path);
    return svg;
  }

  function logoFor(make) {
    return logos[fold(make)] || '';
  }

  function fallbackLogo(className) {
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('class', className || 'evm-cs__row-icon');
    svg.setAttribute('viewBox', '0 0 100 37');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('aria-hidden', 'true');
    [
      'M41.4 0.5H41.3L0.4 14.1L0 14.2L1 24L6 26V20.7L10.2 15.8L19.7 15.9L23.9 21.8V27.8H70.8V22L75.1 16H84.6L88.9 21.1V26.1L97.1 24.1L100 8.7L41.4 0.5ZM96.3 23.2L90 24.8V20.7L85.2 14.9H74.7L69.9 21.6V26.7H25V21.4L20.4 15.1L20.2 14.9L9.8 14.8L5 20.3V24.5L2 23.3L1.2 14.9L41.4 1.4L98.8 9.5L96.3 23.2Z',
      'M41.4001 3.29999H41.3001L13.6001 13.5L64.1001 10.6H64.7001L63.6001 5.99999L41.4001 3.29999ZM20.1001 12.2L41.4001 4.29999L62.7001 6.99999L63.4001 9.69999L20.1001 12.2Z',
      'M14.5999 19.5C10.0999 19.5 6.3999 23.2 6.3999 27.7C6.3999 32.2 10.0999 35.9 14.5999 35.9C19.0999 35.9 22.7999 32.2 22.7999 27.7C22.7999 23.2 19.0999 19.5 14.5999 19.5ZM14.5999 34.9C10.5999 34.9 7.3999 31.7 7.3999 27.7C7.3999 23.7 10.5999 20.5 14.5999 20.5C18.5999 20.5 21.7999 23.7 21.7999 27.7C21.7999 31.7 18.5999 34.9 14.5999 34.9Z',
      'M79.9 19.5C75.4 19.5 71.7 23.2 71.7 27.7C71.7 32.2 75.4 35.9 79.9 35.9C84.4 35.9 88.1 32.2 88.1 27.7C88.1 23.2 84.4 19.5 79.9 19.5ZM79.9 34.9C75.9 34.9 72.7 31.7 72.7 27.7C72.7 23.7 75.9 20.5 79.9 20.5C83.9 20.5 87.1 23.7 87.1 27.7C87.1 31.7 83.9 34.9 79.9 34.9Z',
    ].forEach((d) => {
      const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      path.setAttribute('d', d);
      path.setAttribute('fill', '#111');
      svg.appendChild(path);
    });
    return svg;
  }

  function brandImage(src, className) {
    const fallbackClass = className || 'evm-cs__row-icon';
    if (!src) return fallbackLogo(fallbackClass);
    const img = document.createElement('img');
    img.loading = 'lazy';
    img.decoding = 'async';
    img.src = src;
    img.alt = '';
    if (className) img.className = className;
    img.addEventListener('error', () => {
      img.replaceWith(fallbackLogo(fallbackClass));
    });
    return img;
  }

  function rowButton(label, onClick, opts) {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'evm-cs__row';
    const src = opts && opts.logo;
    if (opts && opts.icon === 'search') {
      const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svg.setAttribute('class', 'evm-cs__row-icon evm-cs__row-icon--search');
      svg.setAttribute('viewBox', '0 0 24 24');
      svg.setAttribute('fill', 'none');
      const circle = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
      circle.setAttribute('cx', '11');
      circle.setAttribute('cy', '11');
      circle.setAttribute('r', '6.5');
      circle.setAttribute('stroke', 'currentColor');
      circle.setAttribute('stroke-width', '1.8');
      const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      path.setAttribute('d', 'M16 16l5 5');
      path.setAttribute('stroke', 'currentColor');
      path.setAttribute('stroke-width', '1.8');
      path.setAttribute('stroke-linecap', 'round');
      svg.appendChild(circle);
      svg.appendChild(path);
      button.appendChild(svg);
    } else if (src || (opts && opts.fallbackLogo)) {
      button.appendChild(brandImage(src));
    }
    const span = document.createElement('span');
    span.className = 'evm-cs__row-label';
    span.textContent = label;
    button.appendChild(span);
    if (!(opts && opts.compact)) button.appendChild(chevron());
    button.addEventListener('click', onClick);
    return button;
  }

  /* Zapytanie, które jest nazwą modelu lub marki (A4, R8, X5, C5 — kolizje z kodami Octavii, Audi A6, Rovera),
     zostaje wyszukiwaniem modelu: modele najpierw, kody niżej, Enter nie skacze do produktu z kodem. */
  function namesModel(query) {
    const q = compact(queryWithoutYear(query, true));
    if (!q || !catalog) return false;
    return catalog.models.some((row) => compact(row.model) === q || compact(row.make + ' ' + row.model) === q) ||
      catalog.makes.some((row) => compact(row.make) === q);
  }

  function codeRow(hit, position, count) {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'evm-cs__row evm-cs__row--code';
    button.appendChild(brandImage(hit.logo));
    const text = document.createElement('span');
    text.className = 'evm-cs__code-text';
    const line = document.createElement('span');
    line.className = 'evm-cs__code-line';
    const name = document.createElement('span');
    name.className = 'evm-cs__code-name';
    name.textContent = hit.make + ' ' + hit.label;
    const chip = document.createElement('span');
    chip.className = 'evm-cs__code-chip';
    chip.textContent = hit.codes.join(' / ');
    line.appendChild(name);
    line.appendChild(chip);
    const meta = document.createElement('span');
    meta.className = 'evm-cs__code-meta';
    meta.textContent = [hit.body, hit.years, hit.note].filter(Boolean).join(' · ');
    text.appendChild(line);
    text.appendChild(meta);
    button.appendChild(text);
    button.appendChild(chevron());
    button.setAttribute('aria-label', [hit.make, hit.label, t('codeLabel'), hit.codes.join(' / '), hit.body, hit.years, hit.note].filter(Boolean).join(', '));
    button.addEventListener('click', () => clickCode(hit, position, count));
    return button;
  }

  function clickCode(hit, position, count) {
    state.searchMethod = 'body_code';
    track('car_search_result_click', { result_type: 'body_code', result_position: position, result_count: count, body_code: hit.matched });
    const catalogModel = catalog && catalog.models.find((row) => row.make === hit.make && row.model === hit.model);
    state.make = hit.make;
    state.model = hit.model;
    state.modelUrl = catalogModel ? catalogModel.url : '';
    state.year = '';
    state.yearRange = String(hit.years).replace('–', '-');
    saveSelection();
    const label = [hit.make, hit.label, hit.codes.join('/'), hit.body].filter(Boolean).join(' ');
    const items = readHistory().filter((item) => item.label !== label);
    items.unshift({ label: label, make: hit.make, model: hit.model, modelUrl: state.modelUrl, year: '', yearRange: state.yearRange, url: hit.url, productUrl: hit.url });
    writeHistory(items);
    track('car_selection_complete', { selected_make: hit.make, selected_model: hit.model, selected_year: state.yearRange, body_code: hit.matched });
    window.location.href = hit.url;
  }

  function renderCodeHits(target, hits) {
    const codes = hits.map((hit) => hit.matched).filter((code, i, all) => all.indexOf(code) === i);
    const wrap = section(codes.length === 1 ? t('codeSection', { code: codes[0] }) : t('codeSectionMany'));
    if (hits.length > 1) {
      const hint = document.createElement('p');
      hint.className = 'evm-cs__code-hint';
      hint.textContent = t('codePick', { count: hits.length });
      wrap.appendChild(hint);
    }
    /* do 12 wierszy wszystko naraz: B8 to Audi A4, Škoda Superb i VW Passat — żaden nie może zniknąć za „zobacz wszystkie” */
    const visible = state.showAll || hits.length <= 12 ? hits : hits.slice(0, 12);
    visible.forEach((hit, index) => wrap.appendChild(codeRow(hit, index + 1, hits.length)));
    if (hits.length > visible.length) {
      wrap.appendChild(rowButton(t('seeAll', { query: state.query }), () => {
        state.showAll = true;
        render();
      }, { icon: 'search' }));
    }
    target.appendChild(wrap);
    renderSiblings(target, hits);
  }

  /* Inne nadwozia tej samej generacji: W204 (sedan) → S204 (kombi), C204 (coupe). Tylko gdy trafienia to jeden
     model; rodzeństwo = ten sam model i ten sam numer kodu (204) albo lata pokrywające się w ≥ 70 %. */
  function renderSiblings(target, hits) {
    const models = hits.map((hit) => hit.make + '|' + hit.model).filter((key, i, all) => all.indexOf(key) === i);
    if (models.length !== 1 || hits.length > 3 || !codeRows) return;
    /* 05.10 przegląd: tylko kody typu W204 / S204 / C204 (litera + 3 cyfry, Mercedes) to to samo pokolenie przy tych
       samych cyfrach; u BMW (E30 / F30) i Audi (8L / 8P) litera oznacza pokolenie — tam porównujemy cały kod */
    const digits = (code) => (/^[a-z]\d{3}$/i.test(String(code)) ? String(code).slice(1) : compact(code));
    const overlap = (a, b) => {
      const x = parseYearRange(a);
      const y = parseYearRange(b);
      if (!x || !y) return 0;
      const common = Math.min(x.end, y.end) - Math.max(x.start, y.start);
      return common <= 0 ? 0 : common / Math.max(1, x.end - x.start);
    };
    const shown = hits.map((hit) => hit.url);
    const siblings = codeRows.filter((row) => row.make + '|' + row.model === models[0] && shown.indexOf(row.url) === -1 &&
      hits.some((hit) => row.codes.some((code) => hit.codes.some((own) => digits(own) && digits(own) === digits(code))) || overlap(hit.years, row.years) >= 0.7));
    if (!siblings.length) return;
    const wrap = section(t('codeSiblings'));
    siblings.slice(0, 6).forEach((row, index) => wrap.appendChild(codeRow(Object.assign({ matched: row.codes[0] }, row), index + 1, siblings.length)));
    target.appendChild(wrap);
  }

  /* Podpowiedź na pustym ekranie: zwykła linijka z przykładami kodów, nic do klikania — klient ma wiedzieć, że wpisuje
     swój kod, a nie wybiera jeden z kilku (właściciel 29.09: «не будет ли клиент думать что можно выбрать только эти»).
     Pole ma aria-describedby="evm-cs-tip", czytnik ekranu przeczyta tę linijkę razem z polem. */
  function renderCodeTip(target) {
    const tip = document.createElement('p');
    tip.className = 'evm-cs__tip';
    tip.id = 'evm-cs-tip';
    tip.textContent = t('codeTip');
    target.appendChild(tip);
  }

  function section(title, extra) {
    const wrap = document.createElement('section');
    wrap.className = 'evm-cs__section';
    const head = document.createElement('div');
    head.className = 'evm-cs__section-head';
    const h3 = document.createElement('h3');
    h3.className = 'evm-cs__section-title';
    h3.textContent = title;
    head.appendChild(h3);
    if (extra) head.appendChild(extra);
    wrap.appendChild(head);
    return wrap;
  }

  function currentPlaceholder() {
    if (state.step === 'year') return t('placeholderYear');
    if (state.step === 'model') return t('placeholderModel');
    return narrowScreen && narrowScreen.matches && i18n.placeholderMakeShort ? t('placeholderMakeShort') : t('placeholderMake');
  }

  function updateChrome() {
    if (state.step === 'model') {
      els.title.textContent = t('titleModel');
      els.subtitle.textContent = t('subModel', { make: state.make });
    } else if (state.step === 'year') {
      els.title.textContent = t('titleYear');
      els.subtitle.textContent = t('subYear', { make: state.make, model: state.model });
    } else {
      els.title.textContent = t('titleMake');
      els.subtitle.textContent = t('subMake');
    }
    els.input.placeholder = currentPlaceholder();
    els.clear.hidden = !state.query;
    renderContext();
  }

  function renderContext() {
    els.context.innerHTML = '';
    if (state.step === 'make' || (!state.make && !state.model)) {
      els.context.hidden = true;
      return;
    }
    els.context.hidden = false;
    const src = logoFor(state.make);
    els.context.appendChild(
      brandImage(src, state.step === 'year' ? 'evm-cs__context-photo' : 'evm-cs__context-logo')
    );
    const info = document.createElement('div');
    const name = document.createElement('p');
    name.className = 'evm-cs__context-name';
    name.textContent = state.step === 'year' ? (state.make + ' ' + state.model).trim() : state.make;
    info.appendChild(name);
    if (state.step === 'year') {
      const meta = document.createElement('p');
      meta.className = 'evm-cs__context-meta';
      meta.textContent = t('yearPick');
      info.appendChild(meta);
    }
    els.context.appendChild(info);
    const actions = document.createElement('div');
    actions.className = 'evm-cs__context-actions';
    const changeMake = document.createElement('button');
    changeMake.type = 'button';
    changeMake.className = 'evm-cs__link';
    changeMake.textContent = t('changeMake');
    changeMake.addEventListener('click', () => changeSelection('make'));
    actions.appendChild(changeMake);
    if (state.step === 'year') {
      const changeModel = document.createElement('button');
      changeModel.type = 'button';
      changeModel.className = 'evm-cs__link';
      changeModel.textContent = t('changeModel');
      changeModel.addEventListener('click', () => changeSelection('model'));
      actions.appendChild(changeModel);
    }
    els.context.appendChild(actions);
  }

  function renderHistory(target) {
    const items = readHistory();
    if (!items.length) return;
    const clear = document.createElement('button');
    clear.type = 'button';
    clear.className = 'evm-cs__link';
    clear.textContent = t('historyClear');
    clear.addEventListener('click', () => {
      writeHistory([]);
      track('car_search_history_delete', { query: 'all' });
      render();
    });
    const wrap = section(t('history'), clear);
    const list = document.createElement('div');
    list.className = 'evm-cs__list';
    items.forEach((item) => {
      const row = document.createElement('div');
      row.className = 'evm-cs__row evm-cs__history-row';
      const labelBtn = document.createElement('button');
      labelBtn.type = 'button';
      labelBtn.className = 'evm-cs__row-label';
      labelBtn.textContent = item.label;
      labelBtn.addEventListener('click', () => useHistory(item));
      const remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'evm-cs__icon-btn';
      remove.setAttribute('aria-label', t('historyRemove'));
      remove.textContent = '×';
      remove.addEventListener('click', (event) => {
        event.stopPropagation();
        writeHistory(readHistory().filter((entry) => entry.label !== item.label));
        track('car_search_history_delete', { query: item.label });
        render();
      });
      row.appendChild(labelBtn);
      row.appendChild(remove);
      list.appendChild(row);
    });
    wrap.appendChild(list);
    target.appendChild(wrap);
  }

  function renderPopularMakes(target) {
    if (!catalog) return;
    const wrap = section(t('popularMakes'));
    const grid = document.createElement('div');
    grid.className = 'evm-cs__popular';
    POPULAR_MAKES.forEach((name) => {
      const make = catalog.makes.find((row) => fold(row.make) === fold(name));
      if (!make) return;
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'evm-cs__tile';
      button.appendChild(brandImage(logoFor(make.make), 'evm-cs__tile-icon'));
      const span = document.createElement('span');
      span.className = 'evm-cs__tile-name';
      span.textContent = make.make;
      button.appendChild(span);
      button.addEventListener('click', () => selectMake(make.make, 'popular'));
      grid.appendChild(button);
    });
    wrap.appendChild(grid);
    target.appendChild(wrap);
  }

  function renderAllMakes(target) {
    if (!catalog) return;
    const wrap = section(t('allMakes'));
    let letter = '';
    catalog.makes.forEach((make) => {
      const next = make.make.charAt(0).toUpperCase();
      if (next !== letter) {
        letter = next;
        const heading = document.createElement('p');
        heading.className = 'evm-cs__letter';
        heading.textContent = letter;
        wrap.appendChild(heading);
      }
      wrap.appendChild(
        rowButton(make.make, () => selectMake(make.make, 'manual'), { logo: make.logo, fallbackLogo: true })
      );
    });
    target.appendChild(wrap);
  }

  function modelsForMake(make) {
    if (!catalog) return [];
    return catalog.models
      .filter((row) => fold(row.make) === fold(make))
      .slice()
      .sort((a, b) => a.model.localeCompare(b.model, undefined, { sensitivity: 'base', numeric: true }));
  }

  function renderPopularModels(target) {
    const names = POPULAR_MODELS[state.make] || [];
    const available = modelsForMake(state.make);
    const popular = names
      .map((name) => available.find((row) => compact(row.model) === compact(name)))
      .filter(Boolean);
    if (!popular.length) return;
    const wrap = section(t('popularModels'));
    const grid = document.createElement('div');
    grid.className = 'evm-cs__popular';
    popular.forEach((row) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'evm-cs__tile';
      const span = document.createElement('span');
      span.className = 'evm-cs__tile-name';
      span.textContent = row.model;
      button.appendChild(span);
      button.addEventListener('click', () => selectModel(row, 'popular'));
      grid.appendChild(button);
    });
    wrap.appendChild(grid);
    target.appendChild(wrap);
  }

  function renderAllModels(target, filterQuery) {
    let rows = modelsForMake(state.make);
    if (filterQuery) {
      const folded = fold(filterQuery);
      const compactQuery = compact(filterQuery);
      rows = rows.filter((row) => fold(row.model).indexOf(folded) !== -1 || compact(row.model).indexOf(compactQuery) !== -1);
    }
    const wrap = section(t('allModels'));
    if (!rows.length) {
      wrap.appendChild(emptyState(false));
      target.appendChild(wrap);
      return;
    }
    rows.forEach((row) => {
      wrap.appendChild(rowButton(row.model, () => selectModel(row, filterQuery ? 'typed' : 'manual')));
    });
    target.appendChild(wrap);
  }

  function renderYears(target, filterQuery) {
    if (state.yearsLoading) {
      const loading = document.createElement('p');
      loading.className = 'evm-cs__loading';
      loading.textContent = t('loading');
      target.appendChild(loading);
      return;
    }
    if (state.yearsError || state.unavailable) {
      const wrap = document.createElement('div');
      wrap.className = 'evm-cs__empty';
      const title = document.createElement('p');
      title.className = 'evm-cs__empty-title';
      title.textContent = state.yearsError ? t('loadError') : t('unavailableTitle');
      wrap.appendChild(title);
      if (state.unavailable) {
        const help = document.createElement('p');
        help.className = 'evm-cs__empty-text';
        help.textContent = t('unavailableText');
        wrap.appendChild(help);
        const link = document.createElement('a');
        link.className = 'evm-cs__cta';
        link.href = localUrl('products/zamowienie-indywidualne');
        link.textContent = t('customOrder');
        wrap.appendChild(link);
      } else {
        const retry = document.createElement('button');
        retry.type = 'button';
        retry.className = 'evm-cs__cta';
        retry.textContent = t('retry');
        retry.addEventListener('click', () => loadModelYears(state.modelUrl));
        wrap.appendChild(retry);
      }
      target.appendChild(wrap);
      return;
    }
    let years = expandYears(state.years);
    if (filterQuery) {
      years = years.filter((year) => String(year).indexOf(String(filterQuery).replace(/\s+/g, '')) !== -1);
    }
    if (!years.length) {
      target.appendChild(emptyState(false));
      return;
    }
    const wrap = section(filterQuery ? t('results') : t('allYears'));
    const grid = document.createElement('div');
    grid.className = 'evm-cs__years';
    const visible = state.showAll || !filterQuery ? years : years.slice(0, QUICK_LIMIT);
    visible.forEach((year, index) => {
      const button = rowButton(
        String(year),
        () => selectYear(String(year), filterQuery ? 'typed' : 'manual', index + 1, years.length),
        { compact: true }
      );
      button.classList.add('evm-cs__year');
      grid.appendChild(button);
    });
    wrap.appendChild(grid);
    if (filterQuery && years.length > QUICK_LIMIT && !state.showAll) {
      wrap.appendChild(
        rowButton(t('seeAll', { query: filterQuery }), () => {
          state.showAll = true;
          render();
        }, { icon: 'search' })
      );
    }
    target.appendChild(wrap);
  }

  function emptyIcon() {
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('class', 'evm-cs__empty-icon');
    svg.setAttribute('width', '88');
    svg.setAttribute('height', '88');
    svg.setAttribute('viewBox', '0 0 88 88');
    svg.setAttribute('fill', 'none');
    const circle = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
    circle.setAttribute('cx', '38');
    circle.setAttribute('cy', '38');
    circle.setAttribute('r', '22');
    circle.setAttribute('stroke', '#fff');
    circle.setAttribute('stroke-width', '3');
    const handle = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    handle.setAttribute('d', 'M54 54l16 16');
    handle.setAttribute('stroke', '#fff');
    handle.setAttribute('stroke-width', '3');
    handle.setAttribute('stroke-linecap', 'round');
    const badge = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
    badge.setAttribute('cx', '64');
    badge.setAttribute('cy', '64');
    badge.setAttribute('r', '12');
    badge.setAttribute('fill', 'var(--color-1, #ef022d)');
    const x1 = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    x1.setAttribute('d', 'M60 60l8 8M68 60l-8 8');
    x1.setAttribute('stroke', '#fff');
    x1.setAttribute('stroke-width', '2');
    x1.setAttribute('stroke-linecap', 'round');
    svg.appendChild(circle);
    svg.appendChild(handle);
    svg.appendChild(badge);
    svg.appendChild(x1);
    return svg;
  }

  function emptyState(hasFuzzy) {
    const wrap = document.createElement('div');
    wrap.className = 'evm-cs__empty';
    wrap.appendChild(emptyIcon());
    const title = document.createElement('p');
    title.className = 'evm-cs__empty-title';
    title.textContent = t('noResults', { query: state.query });
    const text = document.createElement('p');
    text.className = 'evm-cs__empty-text';
    text.textContent = hasFuzzy ? t('noResultsHintClose') : t('noResultsHintNone');
    wrap.appendChild(title);
    wrap.appendChild(text);
    if (!hasFuzzy && state.step === 'make') {
      const cta = document.createElement('button');
      cta.type = 'button';
      cta.className = 'evm-cs__cta';
      cta.textContent = t('pickMakeCta');
      cta.addEventListener('click', () => {
        state.query = '';
        state.showAll = false;
        els.input.value = '';
        render();
      });
      wrap.appendChild(cta);
    }
    return wrap;
  }

  /* ile wierszy od góry to marka + jej modele (0, gdy pierwszy wynik nie jest marką) */
  function brandRowCount(hits) {
    const first = hits[0];
    if (!first || first.kind !== 'make') return 0;
    let count = 1;
    while (count < hits.length && hits[count].kind === 'model' && fold(hits[count].make) === fold(first.make)) count += 1;
    return count;
  }

  /* 05.10 przegląd: jeden rysownik wierszy katalogu (był skopiowany 4×, a kopia przy nazwie modelu zgubiła
     „Zobacz wszystkie” — z „c4” widać było 5 z 13 modeli i nie dało się dojść do reszty) */
  function renderCatalogRows(target, hits, opts) {
    const options = opts || {};
    const wrap = section(options.title || t('results'));
    /* 30.10: klient wpisał MARKĘ → markę i WSZYSTKIE jej modele pokazujemy naraz (BYD ma 17 modeli, było widać 4 + „Zobacz wszystkie”,
       a „Song L DM-i” chował się na końcu). Zapytania o model („c4”) skracają listę jak dotąd. */
    const visibleLimit = options.limit ? Math.max(options.limit, brandRowCount(hits)) : 0;
    const limited = visibleLimit && !state.showAll && hits.length > visibleLimit;
    (limited ? hits.slice(0, visibleLimit) : hits).forEach((hit, index) => {
      wrap.appendChild(
        rowButton(hit.kind === 'make' ? hit.make : hit.make + ' ' + hit.model, () => clickHit(hit, index + 1, hits.length, 'typed'), {
          logo: hit.kind === 'make' ? hit.logo : '',
          fallbackLogo: hit.kind === 'make',
          icon: options.icon,
        })
      );
    });
    if (limited && options.seeAll !== false) {
      wrap.appendChild(rowButton(t('seeAll', { query: state.query }), () => {
        state.showAll = true;
        render();
      }, { icon: 'search' }));
    }
    target.appendChild(wrap);
  }

  function renderResults(target) {
    if (state.step === 'year') {
      renderYears(target, state.query);
      return;
    }
    if (state.step === 'model') {
      const inBrand = codeHits(state.query);
      const exactModel = modelsForMake(state.make).some((row) => compact(row.model) === compact(state.query));
      if (inBrand.length && !exactModel) renderCodeHits(target, inBrand);
      const anyModel = modelsForMake(state.make).some((row) => fold(row.model).indexOf(fold(state.query)) !== -1 || compact(row.model).indexOf(compact(state.query)) !== -1);
      /* po trafieniu kodem nie dokładamy pod spodem „Nie znaleziono” z listy modeli */
      if (anyModel || !inBrand.length) renderAllModels(target, state.query);
      if (inBrand.length && exactModel) renderCodeHits(target, inBrand);
      return;
    }
    const codes = codeHits(state.query);
    if (codes.length && namesModel(state.query)) {
      renderCatalogRows(target, searchCatalog(state.query), { limit: QUICK_LIMIT });
      renderCodeHits(target, codes);
      return;
    }
    if (codes.length) {
      renderCodeHits(target, codes);
      const also = searchCatalog(state.query, QUICK_LIMIT);
      if (also.length) renderCatalogRows(target, also);
      return;
    }
    const all = searchCatalog(state.query);
    const fuzzy = all.length ? [] : fuzzyCatalog(state.query, 3);
    const hits = all.length ? all : fuzzy;
    if (!hits.length) {
      trackOnceNoResults(false);
      target.appendChild(emptyState(false));
      return;
    }
    if (!all.length) {
      trackOnceNoResults(true);
      target.appendChild(emptyState(true));
      renderCatalogRows(target, hits, { title: t('didYouMean'), icon: 'search' });
      return;
    }
    renderCatalogRows(target, hits, { limit: QUICK_LIMIT });
  }

  /* „Szukali i nie znaleźli”: zdarzenie idzie dopiero, gdy brak wyników trwa 1,2 s (albo klient zamyka okno),
     żeby nie liczyć każdego niedokończonego słowa w trakcie pisania. render() kasuje oczekujące zdarzenie,
     a ponownie planuje je tylko wtedy, gdy nowy stan dalej nie ma wyników. */
  let noResultsSentFor = '';
  let noResultsPending = null;
  let noResultsTimer = 0;
  function cancelNoResults() {
    clearTimeout(noResultsTimer);
    noResultsTimer = 0;
    noResultsPending = null;
  }
  function flushNoResults() {
    const pending = noResultsPending;
    cancelNoResults();
    if (!pending || noResultsSentFor === pending.key) return;
    noResultsSentFor = pending.key;
    track('car_search_no_results', pending.extra);
  }
  function trackOnceNoResults(hasClose) {
    const key = state.step + ':' + state.query + ':' + String(hasClose);
    if (noResultsSentFor === key) return;
    noResultsPending = { key: key, extra: { result_count: 0, result_type: hasClose ? 'close' : 'none', query: state.query, step: state.step } };
    clearTimeout(noResultsTimer);
    noResultsTimer = setTimeout(flushNoResults, 1200);
  }

  /* opis pola (aria-describedby) wskazuje podpowiedź tylko wtedy, gdy ona jest na ekranie (05.10 przegląd) */
  function render() {
    renderBody();
    if (document.getElementById('evm-cs-tip')) els.input.setAttribute('aria-describedby', 'evm-cs-tip');
    else els.input.removeAttribute('aria-describedby');
  }
  function renderBody() {
    cancelNoResults();
    updateChrome();
    els.body.innerHTML = '';
    if (!catalog) {
      const loading = document.createElement('p');
      loading.className = 'evm-cs__loading';
      loading.textContent = t('loading');
      els.body.appendChild(loading);
      return;
    }
    if (state.query.trim()) {
      if (state.step !== 'year' && fold(state.query).length < 2) {
        if (state.step === 'model') {
          renderPopularModels(els.body);
          renderAllModels(els.body);
        } else {
          /* jedna litera nie zmienia list — podpowiedź zostaje, żeby lista nie podskakiwała o jej wysokość */
          renderCodeTip(els.body);
          renderHistory(els.body);
          renderPopularMakes(els.body);
          renderAllMakes(els.body);
        }
        return;
      }
      renderResults(els.body);
      return;
    }
    if (state.step === 'make') {
      renderCodeTip(els.body);
      renderHistory(els.body);
      renderPopularMakes(els.body);
      renderAllMakes(els.body);
      return;
    }
    if (state.step === 'model') {
      renderPopularModels(els.body);
      renderAllModels(els.body);
      return;
    }
    renderYears(els.body);
  }

  function clickHit(hit, position, count, method) {
    state.searchMethod = method;
    track('car_search_result_click', {
      result_type: hit.kind === 'make' ? 'make' : 'model',
      result_position: position,
      result_count: count,
    });
    if (hit.kind === 'make') selectMake(hit.make, method);
    else {
      if (state.step === 'make' && hit.make) {
        track('car_make_select', { search_method: method, selected_make: hit.make, selected_model: hit.model });
      }
      selectModel(hit, method);
    }
  }

  function selectMake(make, method) {
    state.searchMethod = method || 'manual';
    state.make = make;
    state.model = '';
    state.modelUrl = '';
    state.year = '';
    state.yearRange = '';
    state.years = [];
    state.query = '';
    state.showAll = false;
    els.input.value = '';
    state.step = 'model';
    track('car_make_select', { search_method: state.searchMethod, selected_make: make });
    render();
  }

  function selectModel(row, method) {
    const pendingYear = parseYearToken(state.query);
    state.searchMethod = method || 'manual';
    state.make = row.make;
    state.model = row.model;
    state.modelUrl = row.url;
    state.year = '';
    state.yearRange = '';
    state.query = '';
    state.showAll = false;
    els.input.value = '';
    state.step = 'year';
    track('car_model_select', { search_method: state.searchMethod, selected_make: row.make, selected_model: row.model });
    loadModelYears(row.url, pendingYear);
  }

  function loadModelYears(url, pendingYear) {
    state.yearsError = false;
    state.unavailable = false;
    state.yearsLoading = true;
    render();
    fetchCollectionYears(url).then((ranges) => {
      if (state.modelUrl !== url) return;
      state.years = ranges || [];
      state.yearsLoading = false;
      state.yearsError = ranges === null;
      state.unavailable = Array.isArray(productsCache[url]) && productsCache[url].length === 0;
      if (state.yearsError || state.unavailable) {
        render();
        return;
      }
      if (!ranges.length) {
        complete();
        return;
      }
      render();
      if (pendingYear) {
        const match = expandYears(ranges).find((item) => String(item) === String(pendingYear)) ||
          (pickRangeForYear(pendingYear, ranges) ? pendingYear : '');
        if (match) selectYear(String(match), 'typed');
      }
    });
  }

  function selectYear(year, method, position, count) {
    const range = pickRangeForYear(year, state.years);
    state.searchMethod = method || 'manual';
    state.year = year;
    state.yearRange = range || year;
    track('car_year_select', {
      search_method: state.searchMethod,
      result_type: 'year',
      result_position: position,
      result_count: count,
      selected_year: year,
    });
    complete();
  }

  function changeSelection(step, silent) {
    if (!silent) track('car_selection_change', { step: step });
    if (step === 'make') {
      state.make = '';
      state.model = '';
      state.modelUrl = '';
      state.year = '';
      state.yearRange = '';
      state.years = [];
      state.step = 'make';
    } else {
      state.model = '';
      state.modelUrl = '';
      state.year = '';
      state.yearRange = '';
      state.years = [];
      state.step = 'model';
    }
    state.query = '';
    state.showAll = false;
    state.yearsError = false;
    state.unavailable = false;
    els.input.value = '';
    render();
  }

  function complete() {
    saveSelection();
    pushHistory();
    track('car_selection_complete', {
      selected_make: state.make,
      selected_model: state.model,
      selected_year: state.year || state.yearRange,
    });
    const url = singleProductUrl() || resultUrl();
    if (url) window.location.href = url;
  }

  function useHistory(item) {
    state.searchMethod = 'history';
    track('car_search_history_click', { query: item.label });
    if (item.productUrl) {
      window.location.href = item.productUrl;
      return;
    }
    if (item.url && item.make && item.model && (item.year || item.yearRange)) {
      state.make = item.make;
      state.model = item.model;
      state.modelUrl = item.modelUrl;
      state.year = item.year;
      state.yearRange = item.yearRange;
      complete();
      return;
    }
    state.make = item.make || '';
    state.model = item.model || '';
    state.modelUrl = item.modelUrl || '';
    state.step = item.model ? 'year' : item.make ? 'model' : 'make';
    state.query = '';
    els.input.value = '';
    render();
    if (state.step === 'year' && state.modelUrl) {
      loadModelYears(state.modelUrl);
    }
  }

  function open(opts) {
    const options = opts || {};
    openSeq += 1;
    state.entry = options.entry || 'default';
    state.step = options.step || 'make';
    state.query = options.query || '';
    state.showAll = false;
    state.yearsError = false;
    state.unavailable = false;
    state.trackedInput = false;
    state.trackedFocus = false;
    if (!options.keepSelection) {
      if (state.step === 'make') {
        state.make = '';
        state.model = '';
        state.modelUrl = '';
        state.year = '';
        state.yearRange = '';
        state.years = [];
      }
    }
    els.input.value = state.query;
    setOpen(true, options.entry === 'search' || options.entry === 'catalog');
    track('car_search_open');
    loadCatalog().then(render);
    render();
  }

  function close() {
    if (!state.open) return;
    flushNoResults();
    track('car_search_cancel');
    setOpen(false);
  }

  function goBack() {
    if (state.query) {
      state.query = '';
      state.showAll = false;
      els.input.value = '';
      render();
      return;
    }
    if (state.step === 'year') {
      track('car_selection_back', { step: 'model' });
      changeSelection('model', true);
      return;
    }
    if (state.step === 'model') {
      track('car_selection_back', { step: 'make' });
      changeSelection('make', true);
      return;
    }
    close();
  }

  function onInput() {
    state.query = els.input.value.trim();
    state.showAll = false;
    if (state.query && !state.trackedInput) {
      state.trackedInput = true;
      track('car_search_input');
    }
    render();
  }

  function onSubmit(event) {
    event.preventDefault();
    const query = els.input.value.trim();
    state.query = query;
    track('car_search_submit', { query: query });
    if (state.step === 'year') {
      const year = parseYearToken(query) || query;
      if (year && expandYears(state.years).some((item) => String(item) === String(year) || String(item).indexOf(String(year)) === 0)) {
        const match = expandYears(state.years).find((item) => String(item) === String(year)) || expandYears(state.years).find((item) => String(item).indexOf(String(year)) === 0);
        if (match) selectYear(String(match), 'typed');
      }
      return;
    }
    const codes = namesModel(query) ? [] : codeHits(query);
    if (codes.length === 1) {
      clickCode(codes[0], 1, 1);
      return;
    }
    if (codes.length > 1) {
      state.showAll = true;
      render();
      return;
    }
    const hits = searchCatalog(query);
    if (hits.length === 1) {
      clickHit(hits[0], 1, 1, 'typed');
      return;
    }
    if (hits[0] && hits[0].kind === 'model' && parseYearToken(query)) {
      selectModel(hits[0], 'typed');
      return;
    }
    state.showAll = true;
    render();
  }

  root.querySelector('[data-evm-cs-back]').addEventListener('click', goBack);
  root.querySelector('[data-evm-cs-cancel]').addEventListener('click', close);
  els.clear.addEventListener('click', () => {
    state.query = '';
    state.showAll = false;
    els.input.value = '';
    els.input.focus();
    render();
  });
  els.input.addEventListener('focus', () => {
    if (!state.open || state.trackedFocus) return;
    state.trackedFocus = true;
    track('car_search_focus');
  });
  els.input.addEventListener('input', onInput);
  els.form.addEventListener('submit', onSubmit);
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && state.open) close();
  });
  window.addEventListener('resize', () => {
    if (!state.open) return;
    root.style.setProperty('--evm-cs-top', headerOffset() + 'px');
    els.input.placeholder = currentPlaceholder(); // obrót telefonu zmienia szerokość pola
  });

  /* 30.09.2026 główna v2 (ТЗ: „после выбора марки открывать выбор модели”): kafelek marki z data-evm-cs-make
     otwiera okno od razu na modelach tej marki. Bez JS kafelek zostaje zwykłym linkiem do kolekcji marki. */
  /* 05.10 przegląd: odpowiedź katalogu dotyczy tylko tego otwarcia okna — po zamknięciu, ponownym otwarciu albo gdy klient
     już coś wpisał, nie przeskakujemy na markę z kafelka i nie czyścimy jego tekstu */
  function openMake(make) {
    const wanted = fold(make);
    const seq = openSeq;
    loadCatalog().then((cat) => {
      if (!state.open || !cat || seq !== openSeq || state.step !== 'make' || state.query) return;
      const hit = cat.makes.find((row) => fold(row.make) === wanted);
      if (hit) selectMake(hit.make, 'brand_tile');
    });
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-evm-cs-open]');
    if (!trigger) return;
    /* Ctrl/Cmd/Shift/środkowy przycisk na linku (kafelek marki, obraz banera) — zwykłe otwarcie w nowej karcie */
    if (trigger.tagName === 'A' && trigger.getAttribute('href') && (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button > 0)) return;
    event.preventDefault();
    open({ entry: trigger.getAttribute('data-evm-cs-open') || 'default' });
    const make = trigger.getAttribute('data-evm-cs-make');
    if (make) openMake(make);
  });

  /* 29.09.2026 — «в один момент пропадает возможность писать в поиск, начальник не смог даже вписать».
     ~8–11 s po wejściu Omnisend otwiera popup newslettera (role=dialog, aria-modal, z-index 200000) POD naszymi
     nakładkami (ta wyszukiwarka z 2147483645, „Wyceń zestaw” z 2147483001): jest niewidoczny, a zabiera fokus
     klawiatury, więc każdy znak trafia do jego ukrytego pola e-mail — i klik w nasze pole nic nie daje, bo pułapka
     fokusu Omnisend go odbiera. Dopóki któraś z naszych nakładek jest otwarta, kontener Omnisend dostaje `inert`:
     popup normalnie się renderuje, ale nie może wziąć fokusu. Po zamknięciu nakładki zdejmujemy tylko nasz `inert`
     i popup działa na tej samej stronie. (display:none nie nadaje się — Omnisend wtedy w ogóle nie pokazuje popupu
     na tej stronie.) Test: tests/omnisend-focus/check-omnisend-focus.mjs */
  const FOREIGN_MODALS = '#omnisend-forms-wrapper';
  let foreignWatch = null;
  function ourOverlayOpen() {
    return state.open || !!document.querySelector('#popupOverlayApplicationForm.show');
  }
  function syncForeignModals() {
    const ours = ourOverlayOpen();
    document.querySelectorAll(FOREIGN_MODALS).forEach((node) => {
      if (ours && !node.hasAttribute('inert')) {
        const hadFocus = node.contains(document.activeElement);
        node.setAttribute('inert', '');
        node.setAttribute('data-evm-inert', '1');
        if (hadFocus && state.open) els.input.focus();
      } else if (!ours && node.getAttribute('data-evm-inert') === '1') {
        node.removeAttribute('inert');
        node.removeAttribute('data-evm-inert');
      }
    });
    /* popup może się pojawić dopiero, gdy nakładka już jest otwarta — obserwator działa tylko na ten czas */
    if (ours && !foreignWatch && window.MutationObserver) {
      foreignWatch = new MutationObserver(() => {
        const wrapper = document.querySelector(FOREIGN_MODALS);
        if (wrapper && !wrapper.hasAttribute('inert')) syncForeignModals();
      });
      foreignWatch.observe(document.body, { childList: true, subtree: true });
    } else if (!ours && foreignWatch) {
      foreignWatch.disconnect();
      foreignWatch = null;
    }
  }
  const wycenOverlay = document.getElementById('popupOverlayApplicationForm');
  if (wycenOverlay && window.MutationObserver) {
    new MutationObserver(syncForeignModals).observe(wycenOverlay, { attributes: true, attributeFilter: ['class'] });
  }

  window.EvmCarSearch = {
    open: open,
    close: close,
    openMake: (make) => { open({ entry: 'api' }); openMake(make); },
  };
})();
